import React from 'react';
import { Card, Typography, Empty } from 'antd';
import { TeamOutlined } from '@ant-design/icons';

const { Title, Paragraph } = Typography;

const Distribuidoras = () => {
  return (
    <div>
      <Title level={3}>Distribuidoras</Title>
      <Card bordered={false} style={{ borderRadius: 8, textAlign: 'center', padding: 40 }}>
        <Empty
          image={<TeamOutlined style={{ fontSize: 64, color: '#E8192C' }} />}
          description={
            <div>
              <Title level={4} style={{ marginTop: 16 }}>Módulo de Distribuidoras</Title>
              <Paragraph type="secondary">
                Gestión completa del programa de distribuidoras: registro, pedidos,
                comisiones (10-20%), Puntos Camello y niveles (Iniciadora → Diamante).
              </Paragraph>
              <Paragraph type="secondary">Disponible en Fase 4</Paragraph>
            </div>
          }
        />
      </Card>
    </div>
  );
};

export default Distribuidoras;
